<div class="row no-gutters">
  @for (notice of notices; track notice) {
    <div class="col-md-12 notice">
      @if (showNotice(notice.filter)) {
        <mat-card class="mat-card {{notice.type}} mb-xxl">
          <mat-card-content>
            @if (notice.type !== 'xmass') {
              <div class="row">
                <div class="col-md-1 text-center my-auto h2 pb-0">
                  <mat-icon>{{ notice.type == 'warn' ? 'error' : 'info' }}</mat-icon>
                </div>
                <div class="col-md-10 align-content-center" [innerHTML]="notice.text"></div>
              </div>
            }
            @if (notice.type === 'xmass') {
              <div class="row">
                <div class="col-md-1 text-center my-auto h2 pb-0">
                  <img src="../../assets/img/icons/gift-icon.svg" alt="Geschenk ikon">
                </div>
                <div class="col-md-10 align-content-center" [innerHTML]="notice.text"></div>
              </div>
            }
          </mat-card-content>
        </mat-card>
      }
    </div>
  }
</div>
